var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-snackbar',_vm._g({attrs:{"value":_vm.value,"data-qa":"vc-toast","color":_vm.getColor,"timeout":_vm.timeout,"bottom":"","left":""}},_vm.$listeners),[_vm._v(" "+_vm._s(_vm.$t(_vm.text))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }